
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/neighbourhoods/hayes",
      function () {
        return require("private-next-pages/neighbourhoods/hayes.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/neighbourhoods/hayes"])
      });
    }
  